(function () {
  "use strict";

  var STORAGE_KEY = "evlg-hallbauer-anfragekorb-v1";
  var currencyFormatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalize(value) {
    return String(value == null ? "" : value)
      .toLocaleLowerCase("de-DE")
      .replace(/ß/g, "ss")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function formatCurrency(value) {
    return typeof value === "number" && Number.isFinite(value) ? currencyFormatter.format(value) : "auf Anfrage";
  }

  function formatNumber(value) {
    return new Intl.NumberFormat("de-DE").format(value || 0);
  }

  function nl2br(value) {
    return escapeHtml(value).replace(/\n/g, "<br>");
  }

  function loadCart() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveCart(cart) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
    } catch (error) {
      /* The cart remains available for the current page session. */
    }
  }

  function initCatalog(root) {
    if (root.dataset.hallbauerInitialized === "true") return;
    root.dataset.hallbauerInitialized = "true";

    var catalog = window.SAMOA_HALLBAUER_CATALOG_DATA;
    var grid = root.querySelector("[data-product-grid]");
    var liveStatus = root.querySelector("[data-live-status]");
    if (!catalog || !Array.isArray(catalog.products)) {
      grid.innerHTML = '<div class="hallbauer-empty"><h3>Produktdaten konnten nicht geladen werden.</h3><p>Bitte laden Sie die Seite erneut.</p></div>';
      grid.setAttribute("aria-busy", "false");
      return;
    }

    var products = catalog.products;
    var productById = new Map(products.map(function (product) { return [product.id, product]; }));
    var spriteUrl = root.dataset.spriteUrl || "";
    var pageSize = Number(root.dataset.pageSize) || 24;
    var visibleLimit = pageSize;
    var state = {
      query: "",
      productArea: "",
      productGroup: "",
      productType: "",
      origin: "",
      sort: "title",
    };
    var cart = loadCart().filter(function (item) { return productById.has(item.id); });

    var searchInput = root.querySelector("[data-search-input]");
    var resultCount = root.querySelector("[data-result-count]");
    var emptyState = root.querySelector("[data-empty-state]");
    var loadMoreWrap = root.querySelector("[data-load-more-wrap]");
    var productModal = root.querySelector("[data-product-modal]");
    var productModalContent = root.querySelector("[data-product-modal-content]");
    var checkoutModal = root.querySelector("[data-checkout-modal]");
    var cartDrawer = root.querySelector("[data-cart-drawer]");
    var overlay = root.querySelector("[data-overlay]");
    var cartItems = root.querySelector("[data-cart-items]");
    var cartEmpty = root.querySelector("[data-cart-empty]");
    var cartFooter = root.querySelector("[data-cart-footer]");
    var cartTotal = root.querySelector("[data-cart-total]");
    var orderPreview = root.querySelector("[data-order-preview]");
    var orderBody = root.querySelector("[data-order-body]");
    var orderForm = root.querySelector(".hallbauer-order-form");

    root.querySelectorAll("[data-product-total]").forEach(function (node) {
      node.textContent = formatNumber(catalog.meta.productCount);
    });

    function populateSelect(filterName, values) {
      var select = root.querySelector('[data-filter="' + filterName + '"]');
      if (!select) return;
      var first = select.options[0].outerHTML;
      select.innerHTML = first + values.map(function (value) {
        return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + "</option>";
      }).join("");
    }

    populateSelect("productArea", catalog.meta.filterValues.productAreas);
    populateSelect("productGroup", catalog.meta.filterValues.productGroups);
    populateSelect("productType", catalog.meta.filterValues.productTypes);
    populateSelect("origin", catalog.meta.filterValues.origins);

    function filterProducts() {
      var queryTokens = normalize(state.query).split(" ").filter(Boolean);
      var filtered = products.filter(function (product) {
        if (queryTokens.length) {
          var haystack = normalize(product.searchText);
          if (!queryTokens.every(function (token) { return haystack.indexOf(token) !== -1; })) return false;
        }
        if (state.productArea && product.productArea !== state.productArea) return false;
        if (state.productGroup && product.productGroup !== state.productGroup) return false;
        if (state.productType && product.productType !== state.productType) return false;
        if (state.origin && product.origin !== state.origin) return false;
        return true;
      });

      filtered.sort(function (a, b) {
        if (state.sort === "price-asc") return (a.ourPrice == null ? Infinity : a.ourPrice) - (b.ourPrice == null ? Infinity : b.ourPrice);
        if (state.sort === "price-desc") return (b.ourPrice == null ? -Infinity : b.ourPrice) - (a.ourPrice == null ? -Infinity : a.ourPrice);
        if (state.sort === "discount-desc") return (b.discountPercent || 0) - (a.discountPercent || 0);
        return a.title.localeCompare(b.title, "de", { numeric: true, sensitivity: "base" });
      });
      return filtered;
    }

    function spriteTileMarkup(index, label, className) {
      if (!Number.isInteger(index) || !spriteUrl) {
        return '<div class="' + className + ' hallbauer-product-image--empty" aria-hidden="true"><span>SH</span></div>';
      }
      var columns = Math.max(1, Number(catalog.meta.sprite.columns) || 1);
      var rows = Math.max(1, Number(catalog.meta.sprite.rows) || 1);
      var tileSize = Math.max(1, Number(catalog.meta.sprite.tileSize) || 320);
      var column = index % columns;
      var row = Math.floor(index / columns);
      var imageStyle = "position:absolute;display:block;width:" + (columns * 100) + "%;height:" + (rows * 100) + "%;max-width:none;left:-" + (column * 100) + "%;top:-" + (row * 100) + "%;";
      return '<div class="' + className + '" role="img" aria-label="Produktbild: ' + escapeHtml(label) + '" style="position:relative;overflow:hidden;">' +
        '<img class="hallbauer-sprite-image" src="' + escapeHtml(spriteUrl) + '" alt="" width="' + (columns * tileSize) + '" height="' + (rows * tileSize) + '" decoding="async" style="' + imageStyle + '">' +
      '</div>';
    }

    function productGalleryMarkup(product) {
      return '<div class="hallbauer-product-detail__gallery">' + product.imageIndexes.map(function (index, imageNumber) {
        return spriteTileMarkup(index, product.title + (imageNumber ? " – Ansicht " + (imageNumber + 1) : ""), "hallbauer-product-detail__image");
      }).join("") + '</div>';
    }

    function priceMarkup(product) {
      if (product.ourPrice == null) {
        return '<div class="hallbauer-price-request"><strong>Preis auf Anfrage</strong><span>Wir erstellen Ihnen gern ein individuelles Angebot.</span></div>';
      }
      var uvpMarkup = product.uvp != null
        ? '<s>UVP ' + formatCurrency(product.uvp) + '</s>' + (product.discountPercent != null ? '<strong>–' + escapeHtml(product.discountPercent.toFixed(1).replace(".", ",")) + ' %</strong>' : '<span>ohne Rabattangabe</span>')
        : '<span>UVP nicht angegeben</span>';
      return '<div class="hallbauer-price-row">' +
        '<div class="hallbauer-price-row__main"><strong>' + formatCurrency(product.ourPrice) + '</strong><span>EVLG Preis</span></div>' +
        '<div class="hallbauer-price-row__uvp">' + uvpMarkup + '</div>' +
      '</div>';
    }

    function cardMarkup(product) {
      var gtin = product.gtin || "nicht angegeben";
      return '<article class="hallbauer-product-card" itemscope itemtype="https://schema.org/Product">' +
        '<div class="hallbauer-product-card__stripe"></div>' +
        spriteTileMarkup(product.imageIndexes[0], product.title, "hallbauer-product-card__image") +
        '<div class="hallbauer-product-card__body">' +
          '<meta itemprop="brand" content="Samoa-Hallbauer GmbH">' +
          '<div class="hallbauer-product-card__eyebrow"><span class="hallbauer-product-card__area">' + escapeHtml(product.productArea) + '</span><span class="hallbauer-product-card__lead">Herkunft ' + escapeHtml(product.origin) + '</span></div>' +
          '<h3 itemprop="name">' + escapeHtml(product.title) + '</h3>' +
          '<p class="hallbauer-product-card__variant">' + escapeHtml(product.productGroup) + ' · ' + escapeHtml(product.productType) + '</p>' +
          '<div class="hallbauer-product-card__codes">' +
            '<div><span>Artikelnummer</span><strong itemprop="sku">' + escapeHtml(product.articleNo) + '</strong></div>' +
            '<div><span>GTIN</span><strong>' + escapeHtml(gtin) + '</strong></div>' +
          '</div>' +
          '<div class="hallbauer-product-card__price" itemprop="offers" itemscope itemtype="https://schema.org/Offer">' +
            (product.ourPrice != null ? '<meta itemprop="priceCurrency" content="EUR"><meta itemprop="price" content="' + product.ourPrice.toFixed(2) + '">' : "") +
            priceMarkup(product) +
          '</div>' +
          '<p class="hallbauer-product-card__meta">Bestelleinheit: ' + escapeHtml(product.minimumOrderQuantity) + ' ' + escapeHtml(product.orderUnit) + '</p>' +
          '<div class="hallbauer-product-card__actions">' +
            '<button class="hallbauer-button hallbauer-button--primary" type="button" data-add-to-cart="' + escapeHtml(product.id) + '">In die Anfrage</button>' +
            '<button class="hallbauer-detail-button" type="button" data-product-detail="' + escapeHtml(product.id) + '" aria-label="Details zu ' + escapeHtml(product.title) + '">i</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    function renderProducts(announce) {
      var filtered = filterProducts();
      var visible = filtered.slice(0, visibleLimit);
      resultCount.textContent = formatNumber(filtered.length);
      grid.innerHTML = visible.map(cardMarkup).join("");
      grid.setAttribute("aria-busy", "false");
      emptyState.hidden = filtered.length !== 0;
      loadMoreWrap.hidden = filtered.length <= visibleLimit;
      if (announce) {
        liveStatus.textContent = formatNumber(filtered.length) + " Produkte gefunden. " + formatNumber(visible.length) + " werden angezeigt.";
      }
    }

    function resetFilters() {
      state.query = "";
      state.productArea = "";
      state.productGroup = "";
      state.productType = "";
      state.origin = "";
      state.sort = "title";
      visibleLimit = pageSize;
      searchInput.value = "";
      root.querySelectorAll("[data-filter]").forEach(function (select) { select.value = ""; });
      root.querySelector("[data-sort]").value = "title";
      renderProducts(true);
    }

    function sanitizeQuantity(product, value) {
      var minimum = Math.max(1, Number(product.minimumOrderQuantity) || 1);
      var quantity = Math.round(Number(value) || minimum);
      return Math.min(9999, Math.max(minimum, quantity));
    }

    function addToCart(id) {
      var product = productById.get(id);
      if (!product) return;
      var existing = cart.find(function (item) { return item.id === id; });
      if (existing) existing.quantity = sanitizeQuantity(product, existing.quantity + 1);
      else cart.push({ id: id, quantity: sanitizeQuantity(product, product.minimumOrderQuantity) });
      saveCart(cart);
      renderCart();
      liveStatus.textContent = product.title + " wurde in den Anfragekorb gelegt.";
      openCart();
    }

    function cartSummary() {
      var total = 0;
      var hasOnRequest = false;
      var lines = cart.map(function (item) {
        var product = productById.get(item.id);
        if (!product) return null;
        var lineTotal = product.ourPrice == null ? null : product.ourPrice * item.quantity;
        if (lineTotal == null) hasOnRequest = true;
        else total += lineTotal;
        return { item: item, product: product, lineTotal: lineTotal };
      }).filter(Boolean);
      return { lines: lines, total: Math.round(total * 100) / 100, hasOnRequest: hasOnRequest };
    }

    function renderCart() {
      var summary = cartSummary();
      var itemCount = summary.lines.reduce(function (sum, line) { return sum + line.item.quantity; }, 0);
      root.querySelectorAll("[data-cart-count]").forEach(function (node) { node.textContent = itemCount; });
      cartEmpty.hidden = summary.lines.length > 0;
      cartFooter.hidden = summary.lines.length === 0;
      cartTotal.textContent = formatCurrency(summary.total) + (summary.hasOnRequest ? " + Anfragepositionen" : "");
      cartItems.innerHTML = summary.lines.map(function (line) {
        var product = line.product;
        return '<div class="hallbauer-cart-item">' +
          '<div><h3>' + escapeHtml(product.title) + '</h3><p class="hallbauer-cart-item__code">Art.-Nr. ' + escapeHtml(product.articleNo) + '</p><span class="hallbauer-cart-item__price">' + (line.lineTotal == null ? "Preis auf Anfrage" : formatCurrency(line.lineTotal)) + '</span></div>' +
          '<div class="hallbauer-cart-item__controls"><label><span class="hallbauer-visually-hidden">Menge</span><input type="number" min="' + escapeHtml(product.minimumOrderQuantity) + '" max="9999" step="1" value="' + escapeHtml(line.item.quantity) + '" data-cart-quantity="' + escapeHtml(product.id) + '"></label><button class="hallbauer-cart-item__remove" type="button" data-cart-remove="' + escapeHtml(product.id) + '">Entfernen</button></div>' +
        '</div>';
      }).join("");
      renderOrderPreview();
    }

    function renderOrderPreview() {
      var summary = cartSummary();
      orderPreview.innerHTML = summary.lines.map(function (line) {
        return '<div class="hallbauer-order-preview__item"><span>' + escapeHtml(line.item.quantity) + ' × ' + escapeHtml(line.product.title) + '<br>Art.-Nr. ' + escapeHtml(line.product.articleNo) + '</span><strong>' + (line.lineTotal == null ? "auf Anfrage" : formatCurrency(line.lineTotal)) + '</strong></div>';
      }).join("") + (summary.lines.length ? '<div class="hallbauer-order-preview__total"><span>Zwischensumme</span><strong>' + formatCurrency(summary.total) + (summary.hasOnRequest ? " + Anfragepositionen" : "") + '</strong></div>' : "");
    }

    function buildOrderBody() {
      var summary = cartSummary();
      var lines = [
        "SAMOA HALLBAUER PRODUKTANFRAGE ÜBER SHOP.EVLG.DE",
        "Hersteller: Samoa-Hallbauer GmbH",
        "Preisliste: " + catalog.meta.priceListLabel,
        "",
        "POSITIONEN",
      ];
      summary.lines.forEach(function (line, index) {
        var product = line.product;
        lines.push((index + 1) + ". " + line.item.quantity + " × " + product.title);
        lines.push("   Artikelnummer: " + product.articleNo);
        lines.push("   GTIN: " + (product.gtin || "nicht angegeben"));
        lines.push("   Produktgruppe: " + product.productGroup);
        lines.push("   Einzelpreis: " + (product.ourPrice == null ? "auf Anfrage" : formatCurrency(product.ourPrice)));
        lines.push("   UVP: " + (product.uvp == null ? "nicht angegeben" : formatCurrency(product.uvp)));
        lines.push("   Positionswert: " + (line.lineTotal == null ? "auf Anfrage" : formatCurrency(line.lineTotal)));
        lines.push("");
      });
      lines.push("ZWISCHENSUMME: " + formatCurrency(summary.total) + (summary.hasOnRequest ? " zzgl. Anfragepositionen" : ""));
      lines.push("");
      lines.push("Hinweis: Unverbindliche Bestellanfrage. Verbindlichkeit entsteht erst durch die Auftragsbestätigung von EVLG.");
      return lines.join("\n");
    }

    function syncBodyLock() {
      var locked = cartDrawer.classList.contains("is-open") || productModal.classList.contains("is-open") || checkoutModal.classList.contains("is-open");
      document.body.classList.toggle("hallbauer-lock-scroll", locked);
    }

    function openCart() {
      overlay.hidden = false;
      cartDrawer.classList.add("is-open");
      cartDrawer.setAttribute("aria-hidden", "false");
      syncBodyLock();
      var closeButton = cartDrawer.querySelector("[data-cart-close]");
      if (closeButton) closeButton.focus();
    }

    function closeCart() {
      overlay.hidden = true;
      cartDrawer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
      syncBodyLock();
    }

    function openModal(modal) {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      syncBodyLock();
      var closeButton = modal.querySelector(".hallbauer-modal__close");
      if (closeButton) closeButton.focus();
    }

    function closeModal(modal) {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      syncBodyLock();
    }

    function openProduct(id) {
      var product = productById.get(id);
      if (!product) return;
      var categoryPath = [product.productArea, product.productGroup, product.productType].filter(Boolean).join(" › ");
      productModalContent.innerHTML = '<article class="hallbauer-product-detail">' +
        '<span class="hallbauer-kicker">Samoa-Hallbauer GmbH</span>' +
        '<h2 id="HallbauerProductModalTitle-' + escapeHtml(root.dataset.sectionId) + '">' + escapeHtml(product.title) + '</h2>' +
        '<p class="hallbauer-product-detail__subtitle">Artikelnummer ' + escapeHtml(product.articleNo) + '</p>' +
        productGalleryMarkup(product) +
        '<div class="hallbauer-product-detail__grid">' +
          '<div class="hallbauer-product-detail__panel"><dl>' +
            '<dt>Hersteller</dt><dd>Samoa-Hallbauer GmbH</dd>' +
            '<dt>Artikelnummer</dt><dd>' + escapeHtml(product.articleNo) + '</dd>' +
            '<dt>GTIN</dt><dd>' + escapeHtml(product.gtin || "nicht angegeben") + '</dd>' +
            '<dt>Zolltarifnummer</dt><dd>' + escapeHtml(product.customsCode || "nicht angegeben") + '</dd>' +
            '<dt>Produkttyp</dt><dd>' + escapeHtml(product.productType) + '</dd>' +
            '<dt>Gewicht</dt><dd>' + escapeHtml(product.weight || "nicht angegeben") + '</dd>' +
            '<dt>Maße</dt><dd>' + escapeHtml(product.dimensions || "nicht angegeben") + '</dd>' +
            '<dt>Herkunftsland</dt><dd>' + escapeHtml(product.origin || "nicht angegeben") + '</dd>' +
            '<dt>Bestelleinheit</dt><dd>' + escapeHtml(product.minimumOrderQuantity) + ' ' + escapeHtml(product.orderUnit) + '</dd>' +
          '</dl><div class="hallbauer-product-detail__path"><strong>Kategorie</strong><br>' + categoryPath + '</div></div>' +
          '<div class="hallbauer-product-detail__price">' + priceMarkup(product) + '<p class="hallbauer-product-card__meta">Nettopreis zuzüglich gesetzlicher Umsatzsteuer. Fracht, Verfügbarkeit und Konditionen werden vor Auftragsbestätigung geprüft.</p><button class="hallbauer-button hallbauer-button--primary hallbauer-button--wide" type="button" data-add-to-cart="' + escapeHtml(product.id) + '">In die Anfrage übernehmen</button></div>' +
        '</div>' +
        '<div class="hallbauer-product-detail__description"><h3>Produktbeschreibung</h3><p>' + nl2br(product.details) + '</p></div>' +
      '</article>';
      openModal(productModal);
      try { history.replaceState(null, "", "#hallbauer-produkt=" + encodeURIComponent(product.id)); } catch (error) { /* optional */ }
    }

    function openCheckout() {
      if (!cart.length) {
        openCart();
        return;
      }
      closeCart();
      renderOrderPreview();
      openModal(checkoutModal);
    }

    searchInput.addEventListener("input", function () {
      state.query = searchInput.value;
      visibleLimit = pageSize;
      renderProducts(true);
    });

    root.querySelector("[data-search-clear]").addEventListener("click", function () {
      searchInput.value = "";
      state.query = "";
      visibleLimit = pageSize;
      renderProducts(true);
      searchInput.focus();
    });

    root.querySelectorAll("[data-filter]").forEach(function (select) {
      select.addEventListener("change", function () {
        state[select.dataset.filter] = select.value;
        visibleLimit = pageSize;
        renderProducts(true);
      });
    });

    root.querySelector("[data-sort]").addEventListener("change", function (event) {
      state.sort = event.target.value;
      renderProducts(true);
    });

    root.querySelectorAll("[data-reset-filters]").forEach(function (button) { button.addEventListener("click", resetFilters); });
    root.querySelector("[data-load-more]").addEventListener("click", function () {
      visibleLimit += pageSize;
      renderProducts(true);
    });

    root.addEventListener("click", function (event) {
      var addButton = event.target.closest("[data-add-to-cart]");
      if (addButton) {
        addToCart(addButton.dataset.addToCart);
        if (productModal.classList.contains("is-open")) closeModal(productModal);
        return;
      }
      var detailButton = event.target.closest("[data-product-detail]");
      if (detailButton) openProduct(detailButton.dataset.productDetail);
      var removeButton = event.target.closest("[data-cart-remove]");
      if (removeButton) {
        cart = cart.filter(function (item) { return item.id !== removeButton.dataset.cartRemove; });
        saveCart(cart);
        renderCart();
      }
    });

    cartItems.addEventListener("change", function (event) {
      var input = event.target.closest("[data-cart-quantity]");
      if (!input) return;
      var product = productById.get(input.dataset.cartQuantity);
      var item = cart.find(function (candidate) { return candidate.id === input.dataset.cartQuantity; });
      if (!product || !item) return;
      item.quantity = sanitizeQuantity(product, input.value);
      input.value = item.quantity;
      saveCart(cart);
      renderCart();
    });

    root.querySelectorAll("[data-cart-open]").forEach(function (button) { button.addEventListener("click", openCart); });
    root.querySelectorAll("[data-cart-close]").forEach(function (button) { button.addEventListener("click", closeCart); });
    root.querySelector("[data-checkout-open]").addEventListener("click", openCheckout);
    root.querySelector("[data-product-close]").addEventListener("click", function () { closeModal(productModal); });
    root.querySelector("[data-checkout-close]").addEventListener("click", function () { closeModal(checkoutModal); });
    overlay.addEventListener("click", closeCart);

    [productModal, checkoutModal].forEach(function (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal(modal);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (productModal.classList.contains("is-open")) closeModal(productModal);
      else if (checkoutModal.classList.contains("is-open")) closeModal(checkoutModal);
      else if (cartDrawer.classList.contains("is-open")) closeCart();
    });

    if (orderForm) {
      orderForm.addEventListener("submit", function (event) {
        if (!cart.length) {
          event.preventDefault();
          closeModal(checkoutModal);
          openCart();
          liveStatus.textContent = "Bitte wählen Sie mindestens ein Produkt aus.";
          return;
        }
        orderBody.value = buildOrderBody();
      });
    }

    var successMessage = root.querySelector("[data-form-success]");
    if (successMessage) {
      cart = [];
      saveCart(cart);
      renderCart();
      openModal(checkoutModal);
      setTimeout(function () { successMessage.focus(); }, 50);
    }

    renderCart();
    renderProducts(false);

    var hashMatch = window.location.hash.match(/^#hallbauer-produkt=(.+)$/);
    if (hashMatch) {
      var hashId = decodeURIComponent(hashMatch[1]);
      if (productById.has(hashId)) setTimeout(function () { openProduct(hashId); }, 0);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-hallbauer-root]").forEach(initCatalog);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  else initAll(document);

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
